import classNames from 'classnames';

type AppendDefaultContainerClassNameArgs = (
  className?: string,
  error?: string,
  touched?: boolean,
) => string;

export const appendDefaultContainerClassNames: AppendDefaultContainerClassNameArgs = (
  className,
  error,
  touched,
) =>
  classNames(
    'relative w-full border-0',
    error && touched ? 'rounded-t-md rounded-b-none !border-red-light border-1' : 'rounded-md',
    className,
  );
